import { render, staticRenderFns } from "./TriggersTab.vue?vue&type=template&id=484a8240&scoped=true&"
import script from "./TriggersTab.vue?vue&type=script&lang=js&"
export * from "./TriggersTab.vue?vue&type=script&lang=js&"
import style0 from "./TriggersTab.vue?vue&type=style&index=0&id=484a8240&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484a8240",
  null
  
)

export default component.exports